import React from "react";

export type FilterContextType = {
    filters: {};
    setFilters: (filters: {}) => void;
    search: {};
};

export const FilterContext = React.createContext<FilterContextType>({
    filters: {},
    setFilters: () => { },
    search: {},
});

export type ListContextType = {
    lists: {};
};

export const ListContext = React.createContext<ListContextType>({
    lists: {},
});